import isomorphicFetch from 'isomorphic-fetch';
import { showNotification } from 'react-admin';

import HttpCode from './Constants/HttpCode';
import ServerUrl from './Constants/ServerUrl';

const BasePath = ServerUrl + '/api/v3';

const Fetch = (url: string, params: any) => {
  const token = localStorage.getItem('token');
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  };
  const query_params = Object.keys(params).map((key) => (
    [key, params[key]].map(encodeURIComponent).join('=')
  )).join('&');

  return isomorphicFetch(BasePath + url + '?' + query_params, {
    method: 'GET', headers: headers
  })
    .then(response => {
      if (response.status !== HttpCode.OK.valueOf()) {
        const msg = `${response.status} error when calling "${url}`;

        showNotification('ERROR: ' + msg, 'error')

        const error = new Error(msg);
        (error as any).response = response;
        console.error(error);

        throw error;
      }

      if (params.returnResponse) {
        return Promise.resolve(response);
      } else {
        return response.json();
      }
    });
}

export default Fetch;



// WEBPACK FOOTER //
// ./src/views/Framework/Fetch.tsx